export const PaymentType = {
  onApplicant: 1,
  onAccount: 2,
};